import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";

export function ContextualContentCta({
  href,
  label,
  source,
}: {
  href?: string | null;
  label?: string | null;
  source: "library" | "forum";
}) {
  if (!href || !label) return null;
  return (
    <Card className="border-primary/30 bg-primary/5">
      <CardContent className="flex flex-col justify-between gap-4 p-5 sm:flex-row sm:items-center">
        <div>
          <p className="text-muted-foreground text-xs uppercase tracking-wide">
            Bir sonraki adım
          </p>
          <strong className="mt-1 block text-lg">{label}</strong>
        </div>
        <Button asChild>
          <Link
            to={href}
            data-analytics-cta={`${source}_contextual_cta`}
            data-analytics-destination={href}
          >
            {label} <ArrowRight className="ml-2 h-4 w-4" />
          </Link>
        </Button>
      </CardContent>
    </Card>
  );
}
